export default __webpack_public_path__ + "static/media/InProgress.3b65d851.svg";